const Tabs = () => { return import(/* webpackChunkName: 'tabs' */ './Tabs.vue'); };
const Tab = () => { return import(/* webpackChunkName: 'tab' */ './Tab.vue'); };

export {
    Tabs,
    Tab,
};
